/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineRuleAllowedValues extends models.TagBaselineRule {
    constructor() {
        super();
        this.setDiscriminator("TagBaselineRuleAllowedValues");
    }

    getFixupPrototypeFunction() { return TagBaselineRuleAllowedValues.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineRuleAllowedValues>): TagBaselineRuleAllowedValues {
        let obj = Object.assign(new TagBaselineRuleAllowedValues(), model);
        TagBaselineRuleAllowedValues.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineRuleAllowedValues>): TagBaselineRuleAllowedValues {
        if (!model) return null;
        return TagBaselineRuleAllowedValues.newInstance(<TagBaselineRuleAllowedValues> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineRuleAllowedValues) {
        if (!obj) return;

        models.TagBaselineRuleAllowedValues.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineRuleAllowedValues): boolean {
        if (models.TagBaselineRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineRuleAllowedValues.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed values for this tag
     */
    allowed_values: Array<string>;

}
